import {
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ClientConfigClass;
function ClientConfig() {
  if (ClientConfigClass === VOID) {
    class $ {
      constructor(prereleaseMode, auth0ClientId, auth0Domain, basename, expressEnv, webpackPublicPath, websocketHost) {
        this.p7d_1 = prereleaseMode;
        this.q7d_1 = auth0ClientId;
        this.r7d_1 = auth0Domain;
        this.s7d_1 = basename;
        this.t7d_1 = expressEnv;
        this.u7d_1 = webpackPublicPath;
        this.v7d_1 = websocketHost;
      }
      toString() {
        return 'ClientConfig(prereleaseMode=' + this.p7d_1 + ', auth0ClientId=' + this.q7d_1 + ', auth0Domain=' + this.r7d_1 + ', basename=' + this.s7d_1 + ', expressEnv=' + this.t7d_1 + ', webpackPublicPath=' + this.u7d_1 + ', websocketHost=' + this.v7d_1 + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.p7d_1);
        result = imul(result, 31) + getStringHashCode(this.q7d_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r7d_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.s7d_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.t7d_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.u7d_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.v7d_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientConfig()))
          return false;
        if (!(this.p7d_1 === other.p7d_1))
          return false;
        if (!(this.q7d_1 === other.q7d_1))
          return false;
        if (!(this.r7d_1 === other.r7d_1))
          return false;
        if (!(this.s7d_1 === other.s7d_1))
          return false;
        if (!(this.t7d_1 === other.t7d_1))
          return false;
        if (!(this.u7d_1 === other.u7d_1))
          return false;
        if (!(this.v7d_1 === other.v7d_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ClientConfig');
    ClientConfigClass = $;
  }
  return ClientConfigClass;
}
//region block: exports
export {
  ClientConfig as ClientConfig2mpft8d5d0hh3,
};
//endregion

//# sourceMappingURL=ClientConfig.mjs.map
